import React from 'react';
import styled from 'styled-components';

import useHover from 'shared/hooks/use-hover';
import DownArrow from '@dutchie/common/components/down-arrow-icon';

const variants = {
  large: {
    fontSize: '19px',
    arrowTop: '-5px',
    arrowWidth: '6px',
  },
  medium: {
    fontSize: '15px',
    arrowTop: '-3px',
    arrowWidth: '5px',
  },
  small: {
    fontSize: '13px',
    arrowTop: '-2px',
    arrowWidth: '4px',
  },
};

function DefaultDropdownLabel({ children, onToggle, variant, borderless }) {
  const [hoverRef, isHovered] = useHover();

  return (
    <Wrapper onClick={onToggle} ref={hoverRef}>
      <Container className='dropdown-label' isHovered={isHovered} variant={variant} borderless={borderless}>
        {children}

        <ArrowContainer className='arrow-icon' isHovered={isHovered} variant={variant}>
          <DownArrow />
        </ArrowContainer>
      </Container>
    </Wrapper>
  );
}

export default React.memo(DefaultDropdownLabel);

const Wrapper = styled.div`
  cursor: pointer;
  position: relative;
`;

const Container = styled.div`
  border: 1px solid ${({ borderless, isHovered }) => (isHovered && !borderless ? '#4597e0' : 'transparent')};
  border-radius: 4px;
  color: ${(props) => (props.isHovered ? '#4597e0' : '#46494c')};
  font-size: ${({ variant }) => variants[variant]?.fontSize || '19px'};
  font-weight: bold;
  padding: 10px 40px 10px 10px;
  z-index: 2;

  :focus,
  :active {
    outline: none;
  }
`;

const ArrowContainer = styled.div`
  height: 8px;
  margin-top: ${({ variant }) => variants[variant]?.arrowTop || '-5px'};
  position: absolute;
  right: 24px;
  top: 32%;
  width: ${({ variant }) => variants[variant]?.arrowWidth || '8px'};

  svg {
    transform: rotate(-90deg);
  }

  path {
    fill: ${(props) => (props.isHovered ? '#4597e0' : '#000')};
  }
`;
